/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

/**
 * ClientEvents originate from the client and are sent to the server
 */
export enum ClientEvents {
  Authentication = 'authentication',
}

/**
 * Helper type to access the interface that a websocket message should have
 */
export declare type ClientEvent<EventType extends ClientEvents> = {
  type: EventType;
  payload: ClientEventInterfaces[EventType];
};

/**
 * The token is assigned to the user upon a successful login and can be found in the cookie of the same name
 */
class Authentication {
  authenticationToken!: string;
}

/**
 * Mappings of the events to their respective interfaces
 */
export interface ClientEventInterfaces {
  [ClientEvents.Authentication]: Authentication;
}

/**
 * Mappings of the events to their respective validator classes
 */
export const ClientEventClasses: ClientEventClassesMapping = {
  [ClientEvents.Authentication]: Authentication,
};

/**
 * Helper type for mapping the validator classes
 */
type ClientEventClassesMapping = {
  [ClientEvent in ClientEvents]: new (...args: any[]) => ClientEventInterfaces[ClientEvent];
};
